export const DEFAULT_SAY_TEXT_SPEAKER = 1;
export const DEFAULT_SAY_TEXT_SPEED_SCALE = 1.0;
export const DEFAULT_SAY_TEXT_PITCH_SCALE = 0.0;

export const SAY_TEXT_SPEED_SCALE_MIN = 0.5;
export const SAY_TEXT_SPEED_SCALE_MAX = 2.0;
export const SAY_TEXT_PITCH_SCALE_MIN = -0.15;
export const SAY_TEXT_PITCH_SCALE_MAX = 0.15;

export const SAY_TEXT_VOICES = [
  { speaker: 1, label: 'ずんだもん' },
  { speaker: 42, label: 'ちび式じい' },
  { speaker: 73, label: '満別花丸' },
] as const;
